import React from 'react'
import EventList from '../components/Event/EventList'

export default function Events() {
  return (
    <React.Fragment>
      <EventList />
    </React.Fragment>
  )
}
